import { render, staticRenderFns } from "./role-add.vue?vue&type=template&id=68316943&scoped=true&"
import script from "./role-add.vue?vue&type=script&lang=ts&"
export * from "./role-add.vue?vue&type=script&lang=ts&"
import style0 from "./role-add.vue?vue&type=style&index=0&id=68316943&prod&lang=css&"
import style1 from "./role-add.vue?vue&type=style&index=1&id=68316943&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68316943",
  null
  
)

export default component.exports